import type { Experiment } from '@/types/aggregation/home';

export const AMPLITUDE_EXPERIMENTS = {
    ENABLE_GAME_LAUNCH_MOBILE_WEB: 'enable-game-launch-mobile-web',
    SWJ_TICKER_REDESIGN: 'casino-jackpots-ticker-pill',
    REMIND_ME_WEB: 'remind-me-web',
    /** Mobile web only: lobby builds launcher URLs on same host under `/game-play`. */
    SAME_DOMAIN_LAUNCH: 'same_domain_launch',
    SWJ_INTERSTITIAL_V2: 'swj-interstitial-v2',
    SIMILAR_GAMES: 'similar-games-web',
    /** Lobby: run GeoComply locate once per session after UM login (align Amplitude key with Android experiment). */
    GEOLOCATION_LOGIN: 'geolocation_login',
    TOP_NAV_RANKING: 'top-nav-ranking',
    SEARCH_ML: 'search-ml',
    /** Redirect between launcher and gw domains based on useGameWindow cookie. */
    GAME_WINDOW_V3: 'game-window-v3'
} as const;

export const getExperimentValue = (experiments: Experiment, experimentKey: string): string | undefined => {
    return experiments?.[experimentKey]?.value;
};

export const isExperimentEnabled = (experiments: Experiment, experimentKey: string): boolean => {
    return getExperimentValue(experiments, experimentKey) === 'on';
};
